// Datos de contacto y enlaces de la landing (medix.cl). Cambiar aquí y volver a publicar.
export const CONTACT = {
  // Formato internacional, solo dígitos.
  whatsapp: '56986532326',
  email: 'contacto@medix.cl',
};

// URL de la Web App de Google Apps Script que avisa por email de cada lead.
// Vacío = sin aviso (los leads igual quedan en Firestore). Ver docs/landing-apps-script/.
export const LEADS_SCRIPT_URL = '';

export const APP_URL = '/app';

export const whatsappLink = (text = 'Hola, quiero saber más sobre Medix.') =>
  `https://wa.me/${CONTACT.whatsapp}?text=${encodeURIComponent(text)}`;
